import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { InvoicesService } from '../../services/invoices.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { BillingPortalProps } from '../../models/BillingPortalProps';
import { BansStorageService } from '../../services/bans-storage.service';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.css']
})
export class PaymentMethodsComponent implements OnInit{
  url :any;
  data:any;
  banCAs = new Map<string, Array<string>>();
  ban: string = "";
  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  customerIDs: Array<string> = [];
  banflag: boolean = false;
  apigeeToken: any;

  constructor(private sanitizer: DomSanitizer,
    private invoicesService: InvoicesService,
    private storageService : SessionStorageService, private bansService: BansStorageService) { 
  }

  async ngOnInit(): Promise<void> {
    this.getBans();
  }

  @ViewChild('myDiv')
  myDiv!: ElementRef;

  onIFrameLoaded($event: any) {
    window.removeEventListener("message", this.onIFrameLoaded, true);
    if($event.data === 'FrameLoaded') {
      let iframe = this.myDiv && this.myDiv.nativeElement as HTMLIFrameElement;
      if(iframe && iframe.contentWindow) {
        let billingProps = environment.billingProps;
        var azureClientID = billingProps.aud;
        let msalKeys = localStorage.getItem(`msal.token.keys.${azureClientID}`);
        let accessToken = JSON.parse(msalKeys??"{}").accessToken[0];
        var requestData ={
              ban : this.ban,
              BillingPortalProps : billingProps,
              msalKeys : msalKeys,
              azureTokenData: localStorage.getItem(accessToken),
              apigeeToken :this.apigeeToken
            }
        iframe.contentWindow.postMessage(requestData, environment.serverFURL);
      }
    }
  }

  getBans() {
      this.bansService.bans.subscribe((bans: any) => {
        if (bans) {
          this.banCAs = bans;
          let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
          let firstBAN: any = this.banCAs.entries().next().value;
          this.ban = ban ? ban : firstBAN[0];
          if (window.addEventListener) {
            window.addEventListener("message", this.onIFrameLoaded.bind(this), true);
          }
          this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.serverFURL + "invoices/speedframe?original="+window.origin+"&ban="+this.ban+"&callbackurl=/invoices");
      }
    })
  }

  selectBan(selectedBan: string): void {
    this.ban = selectedBan;
    if (this.ban != "BAN") {
      if (window.addEventListener) {
        window.addEventListener("message", this.onIFrameLoaded.bind(this), true);
      }
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.serverFURL + "invoices/speedframe?original="+window.origin+"&ban="+this.ban+"&callbackurl=/invoices");
    }
  }
}
